import { AlertTriangle, CheckCircle2 } from "lucide-react"
import { Button } from "shared/ui/button"
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "shared/ui/dialog"

interface ChangeWorkTimeResultDialogProps {
  open: boolean
  status: "success" | "error"
  message: string
  onOpenChange: (open: boolean) => void
}

export function ChangeWorkTimeResultDialog({
  open,
  status,
  message,
  onOpenChange,
}: ChangeWorkTimeResultDialogProps) {
  const isSuccess = status === "success"

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className={`flex items-center gap-2 ${isSuccess ? "text-emerald-700" : "text-red-700"}`}>
            {isSuccess ? <CheckCircle2 className="h-5 w-5" /> : <AlertTriangle className="h-5 w-5" />}
            {isSuccess
              ? "\u0e40\u0e1b\u0e25\u0e35\u0e48\u0e22\u0e19\u0e41\u0e1b\u0e25\u0e07\u0e40\u0e27\u0e25\u0e32\u0e01\u0e32\u0e23\u0e17\u0e33\u0e07\u0e32\u0e19\u0e2a\u0e33\u0e40\u0e23\u0e47\u0e08"
              : "\u0e44\u0e21\u0e48\u0e2a\u0e32\u0e21\u0e32\u0e23\u0e16\u0e40\u0e1b\u0e25\u0e35\u0e48\u0e22\u0e19\u0e41\u0e1b\u0e25\u0e07\u0e40\u0e27\u0e25\u0e32\u0e01\u0e32\u0e23\u0e17\u0e33\u0e07\u0e32\u0e19\u0e44\u0e14\u0e49"}
          </DialogTitle>
        </DialogHeader>
        <div className="whitespace-pre-line text-sm text-slate-600">{message}</div>
        <DialogFooter>
          <Button
            onClick={() => onOpenChange(false)}
            className={
              isSuccess ? "bg-emerald-600 text-white hover:bg-emerald-700" : "bg-red-600 text-white hover:bg-red-700"
            }
          >
            {"\u0e15\u0e01\u0e25\u0e07"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
